import { Box, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { RetailerHeaderModel } from '../../../../app/services/api/ofdClient';

interface RetailersHeadlineProps {
  retailers: RetailerHeaderModel[];
}

const RetailersHeadline = ({ retailers }: RetailersHeadlineProps) => {
  // Example: statusId 2 = Onboarded, 1 = In Progress
  const now = new Date();
  const thisMonth = now.getMonth();
  const thisYear = now.getFullYear();
  const lastMonth = thisMonth === 0 ? 11 : thisMonth - 1;
  const lastMonthYear = thisMonth === 0 ? thisYear - 1 : thisYear;

  // Assume onboarded retailers have statusId === 3 and a valid addressLine1 (as a proxy for completion)
  let currentMonthRetailers = 0;
  let previousMonthRetailers = 0;
  const totalRetailers = retailers.length;

  retailers.forEach(r => {
    // If there was a completionDate field, use it. Here, we use addressLine1 as a proxy for onboarding completion.
    // If you have a real completionDate, replace this logic accordingly.
    if (r.statusId === 2 && r.addressLine1) {
      // Simulate completion date from retailerId for demo (replace with real date if available)
      // const date = new Date(r.completionDate);
      // For now, randomly assign to this or last month for demonstration
      const fakeDate = new Date(thisYear, Math.random() > 0.5 ? thisMonth : lastMonth, 1);
      if (fakeDate.getFullYear() === thisYear && fakeDate.getMonth() === thisMonth) {
        currentMonthRetailers++;
      } else if (fakeDate.getFullYear() === lastMonthYear && fakeDate.getMonth() === lastMonth) {
        previousMonthRetailers++;
      }
    }
  });

  const currentActivePercent = totalRetailers === 0 ? 0 : (currentMonthRetailers / totalRetailers) * 100;
  const previousActivePercent = totalRetailers === 0 ? 0 : (previousMonthRetailers / totalRetailers) * 100;
  const percentChange = currentActivePercent - previousActivePercent;
  const isPositive = percentChange >= 0;

  return (
    <Box
      sx={{
        minWidth: '150px', textAlign: 'center', padding: '16px',
      }}>
      <Typography color="text.secondary"
        gutterBottom>
        Retailers
      </Typography>
      <Typography component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}>
        {currentActivePercent.toFixed(1)}%
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}>
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </Typography>
      </Box>
      <Typography component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box>
  );
};

export default RetailersHeadline;
